import apiFetch from '../apiFetch'

export default function (dossierId, token, filter) {
  return apiFetch({ endPoint: `document/UploadedAll?dossierId=${dossierId}`, method: 'POST', token: token, body: filter })
}
